import styled from 'styled-components';
import { Typography, Switch } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import { TextField } from '@mui/material';
import { MediaQuerys } from '../../styles/GlobalStyle';

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;


export const Text = styled(Typography)(() => {
    const { colors } = useColors();
    return {
        color: colors.red,
        fontSize: 16,
        fontWeight: 'bold',
        margin: 0,
        padding: 0,
    }
})

export const TextSwitch = styled(Typography)((props) => {
    const { colors } = useColors();
    return {
        fontSize: '12px',
        fontWeight: 600,
        color: colors.white,
        backgroundColor: `${props.enabled ? colors.green : colors.red}`,
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: '5px',
        padding: '1px 4px',
        [desktop]: {
            fontSize: '0.75rem'
        }
    }
})

export const CustomSwitch = styled(Switch)(() => {
    const { colors } = useColors();
    return {
        "& .MuiSwitch-switchBase": {
            color: colors.disabled
        },
        "& .MuiSwitch-track": {
            backgroundColor: colors.disabled
        },
        "& .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track": {
            color: 'red',
            backgroundColor: 'red',
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            color: 'green'
        },
        "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
            backgroundColor: 'green'
        },
        [desktop]: {
            width: '50px',
            marginRight: '5px'
        }
    }
})


export const Container = styled('div')(() => {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    }
})


export const ContainerGroupTwo = styled('div')(() => {
    return {
        marginTop: '16px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        justifyContent: 'space-between',
        alignItems: 'center',
    }
})


export const ContainerGroupOne = styled('div')(({ isDown }) => {
    return {
        marginTop: isDown && '16px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    }
})


export const CustomTextField = styled(TextField)(() => {
    return {
        width: '100%',
        height: '100%',
        [mobile]: {
            '& .MuiInputBase-input': {
                fontSize: '0.85rem'
            }
        },
        [desktop]: {
            '& .MuiInputBase-input': {
                fontSize: '0.85rem'
            }
        }
    }
})